module.exports = __webpack_public_path__ + "static/media/editIconChanged.7ecdeb65.svg";